import React, { useEffect, useState } from 'react';
import { useCurrentMatchesTeam } from '../../hooks/matches';
import SideSectionCurrentMatchesItem from './SideSectionCurrentMatchesItem';
import { getCurrentMatchesPrefixed } from '../../utils/matches';
import moment from 'moment/moment';
import SideCurrentMatchesRow from '../Matches/SideCurrentMatchesRow';

const SideSectionCurrentMatches = ({ abbrv, endpointUrl }) => {
  const [matches, setMatches] = useState(null);
  const [data, loading, error] = useCurrentMatchesTeam(abbrv, endpointUrl);

  useEffect(() => {
    if (data && !loading && !error) {
      const sortedData = getCurrentMatchesPrefixed(data);
      setMatches(sortedData);
    }
  }, [data]);

  const renderHeader = (item) => {
    const isToday = moment(item.sortId).isSame(moment(), 'day');
    const title = !isToday
      ? moment(item.sortId).format('DD/MM')
      : `Idag ${moment(item.sortId).format('HH:mm')}`;

    return (
      <div className="col-12 px-2 px-sm-4 pt-2 pt-sm-3 data-container__row">
        <p
          className={
            isToday ? 'badge badge--comp-pink' : 'badge badge--comp-blue-1'
          }
        >
          {title}
        </p>
      </div>
    );
  };

  return matches?.map((item) => {
    if (item?.isHeader) {
      return renderHeader(item);
    }

    return <SideCurrentMatchesRow match={item} />;
  });
};

export default SideSectionCurrentMatches;
